import { Outlet } from 'react-router';

import { Footer } from '@/components/Footer';
import { Navbar } from '@/components/Navbar';

export function NavigationLayout() {
  return (
    <div id='navigation_layout'>
      <Navbar />
      <div id='navigation_outlet'>
        <Outlet />
        <Footer />
      </div>
    </div>
  );
}
